<script setup lang="ts">
definePageMeta({
  custom_meta_data: {
    topic: 'lainnya',
    message: 'Saya tertarik dengan fitur COD Advance KiriminAja'
  }
})

useDefaultMeta({
  title: 'COD Advance | Dana COD Cair Sebelum Paket Diterima',
  description:
    'KiriminAja hadir dengan COD Advance: solusi pencairan dana COD lebih cepat hingga 50% bahkan sebelum paket diterima. Cashflow bisnis tetap lancar.',
  robots: 'index, follow'
})

const faqs = [
  {
    question: 'Apa itu COD Advance?',
    answer:
      'COD Advance adalah fitur KiriminAja yang memungkinkan pencairan sebagian dana COD lebih cepat, sebelum paket diterima pembeli.'
  },
  {
    question: 'Siapa yang dapat menggunakan fitur ini?',
    answer:
      'Hanya akun member terverifikasi dengan performa pengiriman tinggi dan volume transaksi besar yang memenuhi kriteria.'
  },
  {
    question: 'Berapa besar dana yang bisa dicairkan di awal?',
    answer:
      'Hingga <b>50% dari nilai barang per pengiriman</b>, tergantung performa akun dan histori transaksi.'
  },
  {
    question: 'Apakah fitur ini aman?',
    answer:
      'Ya. Semua proses diverifikasi oleh sistem KiriminAja yang terintegrasi, dengan kontrol dan audit digital yang ketat.'
  },
  {
    question: 'Kapan sisa dana COD dilunasi?',
    answer: 'Pelunasan otomatis dilakukan setelah paket diterima pembeli.'
  }
]
</script>

<template>
  <div class="flex flex-col">
    <HeroBase
      title="Akses Dana COD di awal, tanpa menunggu paket sampai"
      sub-title="COD Advance"
      description="Dengan COD Advance, dana COD Anda dapat dicairkan sebagian bahkan sebelum paket diterima pembeli. Solusi untuk menjaga arus kas tetap sehat bagi brand dan perusahaan dengan volume pengiriman tinggi."
      hero-image="/images/cod-advance-banner-1.webp"
    >
      <template #action>
        <div
          class="flex flex-col sm:items-center sm:flex-row gap-2 lg:gap-4 py-2"
        >
          <UiButton
            :to="
              $utm.utmUrl('/login', {
                redirectTo: '/cod-advance'
              })
            "
            label="Ajukan COD Advance"
          />
          <UiButton
            :to="$utm.utmUrlWithCustomMetaData('/kontak-kami')"
            label="Konsultasi dengan Tim Kami"
            variant="primaryOutline"
          />
        </div>
      </template>
    </HeroBase>

    <KeunggulanCodAdvanceSection1 />
    <KeunggulanCodAdvanceSection2 />
    <KeunggulanCodAdvanceSection3 />
    <KeunggulanCodAdvanceSection4 />
    <FaqBase :faqs="faqs" />
    <KeunggulanCodAdvanceCta />
  </div>
</template>
